import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { Icon } from '@iconify/react';
import {
  isSolutionEntity,
  isSolutionModuleEntity,
} from '@ipen-portal/ipen-entity-model';
import { makeEntityContentWithToolbar } from '@ipen-portal/plugin-layout-react';
import { TrpcApiBlueprint } from '@ipen-portal/plugin-trpc-react';

import { solutionDataRequirementApiRef } from './apis';

export const solutionDataRequirementsPlugin = createFrontendPlugin({
  extensions: [
    TrpcApiBlueprint.make({
      name: 'solution-data-requirements-api',
      params: defineParams =>
        defineParams({
          apiRef: solutionDataRequirementApiRef,
          path: 'solution-data-requirements',
        }),
    }),
    ...makeEntityContentWithToolbar({
      params: {
        filter: isSolutionModuleEntity,
        icon: <Icon icon="tabler:delta" />,
        loader: () =>
          import('./components/SolutionDataRequirements/SolutionDataRequirements').then(
            m => <m.SolutionDataRequirements />,
          ),
        path: '/data-requirements',
        title: 'Data Requirements',
        toolbarElements: async () =>
          import('./components/Toolbar/SolutionDataRequirementLegend').then(
            m => m.SolutionDataRequirementLegend,
          ),
      },
    }),
    EntityCardBlueprint.make({
      name: 'solution-data-objects',
      params: {
        filter: isSolutionEntity,
        loader: async () =>
          import('./components/SolutionDataRequirementsCard/SolutionDataRequirementsCard').then(
            m => <m.SolutionDataRequirementsCard />,
          ),
      },
    }),
  ],
  pluginId: 'solution-data-requirements',
});
